import React from "react";
import { Outlet } from "react-router-dom";

const OnlyClientAccountPermissionRoute: React.FC = () => {
    return <Outlet />
};

export default OnlyClientAccountPermissionRoute;
